import { Method } from '@rxap/utilities';
import { OpenApiMethod, HttpMethods, OpenApiParameterType, BaseOpenApiMethod } from '../../open-api.method';
import { AssignmentControllerGetAssignedParameter } from '../../parameters/assignment-controller-get-assigned.parameter';
import { AssignmentControllerGetAssignedResponse } from '../../responses/assignment-controller-get-assigned.response';

interface AssignmentControllerGetAssignedOpenApiParameters {
  parameters: AssignmentControllerGetAssignedParameter;
}

@OpenApiMethod({
  method: HttpMethods.GET,
  apiName: 'customer',
  path: '/assignment/assigned/{year}/{month}/{day}',
  operationId: 'AssignmentController_getAssigned',
  parameters: [
    {
      name: 'year',
      required: true,
      in: OpenApiParameterType.PATH,
    },
    {
      name: 'month',
      required: true,
      in: OpenApiParameterType.PATH,
    },
    {
      name: 'day',
      required: true,
      in: OpenApiParameterType.PATH,
    },
    {
      name: 'byDate',
      required: false,
      in: OpenApiParameterType.QUERY,
    },
  ],
})
export class AssignmentControllerGetAssignedMethod
  extends BaseOpenApiMethod<AssignmentControllerGetAssignedResponse>
  implements Method<AssignmentControllerGetAssignedResponse, AssignmentControllerGetAssignedOpenApiParameters>
{
  public call(parameters: AssignmentControllerGetAssignedOpenApiParameters): Promise<AssignmentControllerGetAssignedResponse> {
    return super.call(parameters);
  }
}
